import {
  Button,
  Card,
  Col,
  ConfigProvider,
  DatePicker,
  Form,
  Image,
  Input,
  notification,
  Popover,
  Row,
  Select,
  TimePicker,
} from "antd";
import es from "antd/lib/locale/es_ES";
import UserMarker from "components/mapMarker/UserMarker";
import CardField from "components/UI/CardField";
import { format } from "date-fns";
import GoogleMapReact from "google-map-react";
import moment from "moment";
import "moment/locale/es";
import { useCallback, useEffect, useRef, useState } from "react";
import { usePlacesWidget } from "react-google-autocomplete";
import InfiniteScroll from "react-infinite-scroll-component";
import { Link, useHistory, useLocation } from "react-router-dom";
import { mapOptions } from "shared/mapConfig";
import { SUPPORTED_SEARCH_COUNTRIES } from "shared/googlePlacesConfig";
import {
  CLASSES_ACTIVITY_TYPE,
  getAllActivities,
  getDefaultActivitySelection,
  getSearcherRouteByType,
  SPORTS_ACTIVITY_TYPE,
} from "../shared/activityCatalog";
import { ReactComponent as DataNotFound } from "../assets/enemy-ghost.svg";
import { ReactComponent as IconSearch } from "../assets/ic-search.svg";
import { ReactComponent as LogoHorizontalMovil } from "../assets/LogoHorizontalMovil.svg";
import {
  getActivityCatalog,
  getFields,
  getGeolocationViaIP,
  getClassesByDateRange,
} from "../services/http";
import { useMediaQuery } from "../shared/utils";
import { CardContent, CardMap } from "./SearchAllFields.styles";

moment.locale("es");
const { Option, OptGroup } = Select;
const dateFormat = "DD MMM YYYY";

const ContentPopover = ({ infoSede }) => (
  <Link to={`searcher/sportscenter/${infoSede.idcentro}`}>
    <CardMap>
      <Col span={8} className="Col-ImagField">
        <Image width={78} height={78} preview={false} src={infoSede.logosede} />
      </Col>
      <Col span={16} className="Col-infoCard">
        <p className="Title-sede">{infoSede.nombresede}</p>
        <p className="Inf-distance">{`${infoSede.distance.toFixed(2)} km`}</p>
        <p className="Inf-direction">{infoSede.direccion}</p>
      </Col>
    </CardMap>
  </Link>
);

const SedeLocation = ({ data }) => (
  <Popover
    content={() => <ContentPopover infoSede={data} />}
    overlayClassName="stylePopover"
  >
    <div className="styleMarker" />
  </Popover>
);

const autocompleteOptions = {
  types: ["address"],
  componentRestrictions: { country: SUPPORTED_SEARCH_COUNTRIES },
  fields: ["formatted_address", "geometry", "address_components"],
};

const SearchAllFields = (props) => {
  const history = useHistory();
  const location = useLocation();
  const getRouteActivityType = useCallback(
    (pathname = location.pathname) =>
      pathname.includes("/searcher/classes")
        ? CLASSES_ACTIVITY_TYPE
        : SPORTS_ACTIVITY_TYPE,
    [location.pathname]
  );

  const today = moment().format("DD MMM YYYY");
  const allHours = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23,
  ];

  const [checkHistory, setCheckHistory] = useState(false);
  const [showFixed, setShowFixed] = useState(false);
  const [selectedDate, setselectedDate] = useState(today);
  const [activityTypes, setActivityTypes] = useState([]);
  const [activities, setActivities] = useState([]);
  const [fetchingData, setFetchingData] = useState(false);
  const [fetchedFields, setFetchedFields] = useState([]);
  const [fields, setFields] = useState([]);
  const [sedes, setSedes] = useState([]);
  const [open, setOpen] = useState(false);
  //const [errorAddress, setErrorAddress] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 0,
    total: 0,
  });
  const [hasMoreFields, setHasMoreFields] = useState(true);
  const [placeLocation, setPlaceLocation] = useState({});
  const [mapCenterLocation, setMapCenterLocation] = useState({});
  const [placesInputController, setPlacesInputController] = useState("");
  const [noFields, setNoFields] = useState(false);
  const isDesktop = useMediaQuery("(min-width: 608px)");

  // ESTADO PARA PUNTOS DE RESERVA EN EL CALENDARIO (VISTA DE CLASES)
  const [calendarReservations, setCalendarReservations] = useState(new Set());
  const [, setFetchingCalendarReservations] = useState(false);
  const lastFetchedMonth = useRef("");

  const loadCalendarReservations = useCallback(async (date) => {
    const isClasses = getRouteActivityType() === CLASSES_ACTIVITY_TYPE;
    if (!isClasses) {
      return;
    }
    
    try {
      const parsedSelectedDate = moment(selectedDate, "DD MMM YYYY");
      const targetDate = date || parsedSelectedDate || moment();
      const monthStr = targetDate.format("YYYY-MM");
      
      const searchParams = history.location.state?.searchParams || {};
      const { latitude, longitude, sport } = searchParams;
      
      const cacheKey = `${monthStr}_${latitude || ""}_${longitude || ""}_${sport || ""}`;
      if (lastFetchedMonth.current === cacheKey) {
        return;
      }
      lastFetchedMonth.current = cacheKey;

      setFetchingCalendarReservations(true);
      
      const start = targetDate.clone().startOf('month');
      const end = targetDate.clone().endOf('month');
      
      const timeParam = start.unix();
      const endtimeParam = end.unix();

      const response = await getClassesByDateRange({
        time: timeParam,
        endtime: endtimeParam,
        latitude,
        longitude,
        sport,
        page: '0',
        size: '1000'
      });

      if (response && response.cod === 1000) {
        const dates = new Set();
        (response.data || []).forEach((item) => {
          const dateStr = item.fecha ? item.fecha.substring(0, 10) : "";
          if (dateStr) {
            dates.add(dateStr);
          }
        });
        setCalendarReservations(dates);
      } else {
        setCalendarReservations(new Set());
      }
    } catch (error) {
      console.error("Error loading calendar reservations:", error);
      setCalendarReservations(new Set());
    } finally {
      setFetchingCalendarReservations(false);
    }
  }, [selectedDate, history.location.state, getRouteActivityType]);

  useEffect(() => {
    const isClasses = getRouteActivityType() === CLASSES_ACTIVITY_TYPE;
    if (isClasses) {
      loadCalendarReservations();
    }
  }, [location.pathname, loadCalendarReservations, getRouteActivityType]);
  const mapRef = useRef(null);
  const mapsRef = useRef(null);
  const antInputRef = useRef(null);
  const [form] = Form.useForm();
  const { ref } = usePlacesWidget({
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    onPlaceSelected: (place) => {
      const country = place.address_components
        .filter((components) => components.types[0] === "country")[0]
        .short_name.toLowerCase();
      // console.log({ place, country });
      setPlaceLocation({
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng(),
        country,
      });
      setMapCenterLocation((prev) => ({
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng(),
      }));
      antInputRef.current.input.value = place?.formatted_address;
      setPlacesInputController(place?.formatted_address);
    },
    language: "es-419",
    options: autocompleteOptions,
  });

  const onPlaceChange = (e) => {
    setPlacesInputController(e.target.value);
  };

  const getSearchCopy = () => {
    const isClasses = getRouteActivityType() === CLASSES_ACTIVITY_TYPE;
    return {
      endMessage: isClasses
        ? "No hay más clases que cumplan los criterios, por favor realiza otra búsqueda"
        : "No hay más canchas que cumplan los criterios, por favor realiza otra búsqueda",
    };
  };

  const searchCopy = getSearchCopy();

  const updateSelectedDate = (selected) => {
    const formattedDate = selected.format("DD MMM YYYY");
    setselectedDate(formattedDate);
  };

  const disabledDate = (current) => {
    // Deshabilitar los días pasados al actual
    return current && current < moment(today, "DD MMM YYYY");
  };

  const disabledHours = (current) => {
    const formDate = form.getFieldValue("date");
    const activeDate = formDate ? formDate.format("DD MMM YYYY") : selectedDate;
    if (moment(today, "DD MMM YYYY") >= moment(activeDate, "DD MMM YYYY")) {
      const actualHour = parseInt(moment().format("HH"), 10);
      return allHours.filter((hora) => hora <= actualHour);
    }
  };

  const defaultTime = () => {
    const datetime = moment(Date.now());
    if (datetime.get("minute") > 30) {
      return moment(
        datetime.set("hour", datetime.get("hour") + 1).set("minute", 0),
        "HH:mm"
      );
    } else {
      // return moment(datetime.set('minute', 30), 'HH:mm');
      return moment(
        datetime.set("hour", datetime.get("hour") + 1).set("minute", 0),
        "HH:mm"
      );
    }
  };

  const initialDateTime = {
    date: moment(selectedDate, dateFormat),
    time: defaultTime(),
  };

  const onFinishFailed = (errorInfo) => {
    //console.log('Failed:', errorInfo);
  };

  const backToTop = () => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  };

  const prepareSedes = (fieldsArr) => {
    const sedesMap = Array.from(
      new Set(fieldsArr.map((arr) => arr.idsede))
    ).map((idsede) => {
      return {
        idsede: idsede,
        idcentro: fieldsArr.find((arr) => arr.idsede === idsede).idcentro,
        logosede: fieldsArr.find((arr) => arr.idsede === idsede).logosede,
        nombresede: fieldsArr.find((arr) => arr.idsede === idsede).nombresede,
        distance: fieldsArr.find((arr) => arr.idsede === idsede).distance,
        direccion: fieldsArr.find((arr) => arr.idsede === idsede).direccion,
        coordenadas: {
          lat: fieldsArr.find((arr) => arr.idsede === idsede).latitud,
          lng: fieldsArr.find((arr) => arr.idsede === idsede).longitud,
        },
      };
    });
    const cleaned = sedesMap.filter((sede) => sede.idsede);
    setSedes(cleaned);
  };

  const syncActivityFields = (
    catalog,
    preferredActivityType = getRouteActivityType(),
    preferredActivity = null,
    options = {}
  ) => {
    const { shouldUpdateForm = true } = options;
    const routeType = preferredActivityType || getRouteActivityType();

    // Filtrar el catálogo al tipo de actividad de la ruta actual
    const filteredCatalog = catalog.filter(
      (at) => String(at.id) === String(routeType)
    );
    const catalogForSelection = filteredCatalog.length > 0 ? filteredCatalog : catalog;
    const { activityType } = getDefaultActivitySelection(
      catalogForSelection,
      routeType
    );
    
    let nextActivity = null;
    if (preferredActivity) {
      nextActivity = getAllActivities(catalogForSelection).find(
        (catalogActivity) => String(catalogActivity.id) === String(preferredActivity)
      ) || null;
    }
    
    // Activity is now optional for both types — no forced default

    setActivities(catalogForSelection);

    if (shouldUpdateForm) {
      form.setFieldsValue({
        activityType: nextActivity?.activityTypeId || activityType?.id,
        activity: nextActivity?.id || undefined,
        sport: nextActivity?.legacySportId || undefined,
      });
    }

    return {
      activityType:
        catalogForSelection.find(
          (catalogActivityType) =>
            String(catalogActivityType.id) ===
            String(nextActivity?.activityTypeId || activityType?.id)
        ) || activityType,
      activity: nextActivity,
    };
  };

  const geoLocationRequestViaIP = async (catalog) => {
    try {
      const request = await getGeolocationViaIP();
      if (request.result) {
        const { geodata } = request;
        const { activityType, activity } = syncActivityFields(
          catalog,
          getRouteActivityType(),
          null
        );
        setMapCenterLocation((prev) => ({
          latitude: geodata.latitude,
          longitude: geodata.longitude,
        }));
        const preparedTime = initialDateTime.date.clone().startOf("day");
        const searchValues = {
          date: initialDateTime.date.format("YYYY-MM-DD"),
          time: preparedTime.unix(),
          activityType: activityType?.id,
          activity: activity?.id,
          sport: activity?.legacySportId || undefined,
          latitude: geodata.latitude,
          longitude: geodata.longitude,
          country: geodata.countryCode.toLowerCase(),
        };
        requestFields(searchValues);

        notification.success({
          message: "Estamos utilizando tu ubicación aproximada",
          description:
            "Utilizamos tu ubicación aproximada para poder brindarte mejores resultados de búsqueda",
          duration: 3,
        });
      }
    } catch (error) {
      notification.warning({
        message: "No podemos acceder a tu ubicación",
        description:
          "Ocurrió un error intentando ubicar tu ubicación de forma aproximada, si el problema persiste por favor contacta a soporte en info@icancha.com",
        duration: 3,
      });
    }
  };

  const requestActivityCatalog = async () => {
    try {
      const response = await getActivityCatalog();
      const { cod, data } = response;
      if (cod === 1000) {
        setActivityTypes(data);
        syncActivityFields(
          data,
          getRouteActivityType(),
          form.getFieldValue("activity")
        );

        return data;
      } else {
        throw new Error(`${cod}`);
      }
    } catch (error) {
      //console.log('error requestSports: ', error);
      notification.warning({
        message: "No podemos hacer contacto con el servidor iCancha",
        description:
          "Ocurrió un error intentando obtener el listado de actividades del servidor, si el problema persiste por favor contacta a soporte en info@icancha.com",
        duration: 3,
      });
    }

    return [];
  };

  const requestFields = async (filters) => {
    try {
      setFetchingData(true);
      const response = await getFields(filters);
      const { cod, data } = response;
      if (cod === 1000) {
        setFetchedFields(data);
        const totalPages = Math.ceil(data.length / 10);
        const currentPage = 0;
        setPagination({
          currentPage,
          totalPages,
        });
        const getFirstPage = paginate(data, 10, currentPage);
        if (totalPages === 1) {
          setHasMoreFields(false);
        }
        setNoFields(false);
        setFields(getFirstPage);
        setFetchingData(false);
      } else {
        throw new Error(`${cod}`);
      }
    } catch (error) {
      setFetchingData(false);
      //console.log('error requestFields: ', error);
      const isClasses = getRouteActivityType() === CLASSES_ACTIVITY_TYPE;
      if (error.message === "1003") {
        notification.warning({
          message: isClasses ? "No hay clases disponibles" : "No hay canchas disponibles",
          description: isClasses
            ? "No tenemos clases disponibles en la zona indicada, por favor intenta en otra ciudad"
            : "No tenemos canchas disponibles en la zona indicada, por favor intenta en otra ciudad",
          duration: 3,
        });
        setNoFields(true);
      } else {
        notification.warning({
          message: "No podemos hacer contacto con el servidor iCancha",
          description: isClasses
            ? "Ocurrió un error intentando obtener el listado de clases del servidor, si el problema persiste por favor contacta a soporte en info@icancha.com"
            : "Ocurrió un error intentando obtener el listado de canchas del servidor, si el problema persiste por favor contacta a soporte en info@icancha.com",
          duration: 3,
        });
        setNoFields(true);
      }
    }
  };

  const onFinish = (values) => {
    const selectedActivity = getAllActivities(activityTypes).find(
      (activity) => String(activity.id) === String(values.activity)
    );
    const nextActivityType =
      selectedActivity?.activityTypeId || values.activityType;
    const previousSearchParams = history.location.state?.searchParams || {};
    const preparedTime = values.time
      ? values.date
          .clone()
          .set("hour", values.time.get("hour"))
          .set("minute", values.time.get("minute"))
          .set("second", 0)
          .set("millisecond", 0)
      : values.date
          .clone()
          .set("hour", 0)
          .set("minute", 0)
          .set("second", 0)
          .set("millisecond", 0);
    const searchValues = {
      date: values.date.format("YYYY-MM-DD"),
      time: preparedTime.unix(),
      activityType: nextActivityType,
      activity: values.activity,
      sport: values.activity
        ? values.sport || selectedActivity?.legacySportId || undefined
        : undefined,
      latitude: 0,
      longitude: 0,
      country:
        placeLocation.country ||
        previousSearchParams.country ||
        "co",
    };
    if (!antInputRef.current.input.value) {
      //setErrorAddress(true);
      searchValues.latitude = mapCenterLocation.latitude;
      searchValues.longitude = mapCenterLocation.longitude;
    } else {
      searchValues.latitude = placeLocation.latitude;
      searchValues.longitude = placeLocation.longitude;
    }
    setFetchedFields([]);
    setFields([]);
    setHasMoreFields(true);

    if (!isDesktop) {
      document.body.scrollTop = 400; // For Safari
      document.documentElement.scrollTop = 400;
    }
    history.replace(
      getSearcherRouteByType(nextActivityType),
      {
      ...(history.location.state || {}),
      searchParams: searchValues,
      activityTypes,
      }
    );
    requestFields(searchValues);
  };

  const paginate = (array, page_size, page_number) => {
    return array.slice(
      page_number * page_size,
      page_number * page_size + page_size
    );
  };

  const showMoreFields = () => {
    setTimeout(() => {
      const nextPage = pagination.currentPage + 1;
      const getAnotherPage = paginate(fetchedFields, 10, nextPage);
      if (getAnotherPage.length === 0) {
        setHasMoreFields(false);
      } else {
        setPagination((prev) => ({ ...prev, currentPage: nextPage }));
        setFields((prev) => [...prev].concat(getAnotherPage));
      }
    }, 500);
  };

  const handleApiLoaded = (map, maps) => {
    mapRef.current = map;
    mapsRef.current = maps;
  };

  const getSelectedDateTime = () => {
    const formDate = form.getFieldValue("date");
    const formTime = form.getFieldValue("time");
    const date = formDate ? formDate.format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
    const preparedTime = formTime
      ? formDate
          .clone()
          .set("hour", formTime.get("hour"))
          .set("minute", formTime.get("minute"))
          .set("second", 0)
          .set("millisecond", 0)
      : formDate
          .clone()
          .set("hour", 0)
          .set("minute", 0)
          .set("second", 0)
          .set("millisecond", 0);
    return { date, time: preparedTime.unix() };
  };

  // History Effect check if user came from Home
  useEffect(() => {
    let mounted = true;

    const initializeSearch = async () => {
      try {
        const historyState = history.location.state;
        const historySearchParams = historyState?.searchParams;
        const historyActivityTypes = historyState?.activityTypes || [];
        const fetchedCatalog = await requestActivityCatalog();
        const catalog = fetchedCatalog.length > 0
          ? fetchedCatalog
          : historyActivityTypes;

        if (!mounted || !historySearchParams) {
          setCheckHistory(true);
          setFetchedFields([]);
          setFields([]);
          setSedes([]);
          setHasMoreFields(true);
          form.setFieldsValue({
            date: initialDateTime.date,
            time: undefined,
          });
          setselectedDate(initialDateTime.date.format("DD MMM YYYY"));
          geoLocationRequestViaIP(catalog);
          return;
        }

        setCheckHistory(true);
        setMapCenterLocation({
          latitude: historySearchParams.latitude,
          longitude: historySearchParams.longitude,
        });

        const selectedDateTime = moment(historySearchParams.time * 1000);
        const now = moment();
        const timeExactOrHalf =
          now.minutes() > 30
            ? now.clone().add(1, "hour").startOf("hour")
            : now.clone().startOf("hour").add(30, "minutes");

        const isMidnight = selectedDateTime.hours() === 0 && selectedDateTime.minutes() === 0 && selectedDateTime.seconds() === 0;
        const isPastTime = selectedDateTime.isBefore(now) && !isMidnight;

        const normalizedSelection = syncActivityFields(
          catalog,
          historySearchParams.activityType || getRouteActivityType(),
          historySearchParams.activity
        );
        const nextSearchParams = {
          ...historySearchParams,
          activityType:
            normalizedSelection.activityType?.id ||
            historySearchParams.activityType ||
            getRouteActivityType(),
          activity:
            normalizedSelection.activity?.id || historySearchParams.activity,
          sport: normalizedSelection.activity
            ? normalizedSelection.activity.legacySportId || historySearchParams.sport
            : undefined,
          ...(isPastTime
            ? {
                time: timeExactOrHalf.unix(),
              }
            : {}),
        };
        const activeDate = isPastTime
          ? timeExactOrHalf
          : selectedDateTime || timeExactOrHalf;

        form.setFieldsValue({
          date: activeDate,
          time: isMidnight
            ? undefined
            : activeDate,
        });
        setselectedDate(activeDate.format("DD MMM YYYY"));

        if (
          isPastTime ||
          nextSearchParams.activityType !== historySearchParams.activityType ||
          nextSearchParams.activity !== historySearchParams.activity ||
          nextSearchParams.sport !== historySearchParams.sport
        ) {
          history.replace(location.pathname, {
            ...historyState,
            searchParams: nextSearchParams,
            activityTypes: catalog,
          });
        }

        requestFields(nextSearchParams);
      } catch (error) {
        if (!checkHistory) {
          const catalog = await requestActivityCatalog();
          if (mounted) {
            setCheckHistory(true);
            geoLocationRequestViaIP(catalog);
          }
        }
      }
    };

    initializeSearch();

    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, location.pathname]);

  // Mobile only Effect
  useEffect(() => {
    const onScroll = () => {
      const newShowFixed = window.scrollY > 400;
      showFixed !== newShowFixed && setShowFixed(newShowFixed);
    };
    document.addEventListener("scroll", onScroll);
    return () => document.removeEventListener("scroll", onScroll);
  });

  useEffect(() => {
    prepareSedes(fields);
  }, [fields]);

  useEffect(() => {
    const maps = mapsRef.current;
    const map = mapRef.current;
    if (sedes.length > 0 && maps) {
      const bounds = new maps.LatLngBounds();
      sedes.forEach((sede) =>
        bounds.extend(
          new maps.LatLng(sede.coordenadas.lat, sede.coordenadas.lng)
        )
      );
      bounds.extend(
        new maps.LatLng(mapCenterLocation.latitude, mapCenterLocation.longitude)
      );
      map.fitBounds(bounds);
    }
  }, [sedes, mapCenterLocation.latitude, mapCenterLocation.longitude]);

  useEffect(() => {
    if (props.hamburguercolor) {
      props.hamburguercolor("#ffff");
    }
  }, [props]);

  // Debugger Effect
  /*   useEffect(() => {
    setFetchedFields(aval);
    const totalPages = Math.ceil(aval.length / 10);
    const currentPage = 1;
    setPagination({
      currentPage,
      totalPages,
    });
    //console.log({ totalPages });
    const getFirstPage = paginate(aval, 10, 1);
    debugger;
    setFetchingData(true);
    setTimeout(() => {
      setFields(getFirstPage);
      setFetchingData(false); 
    }, 2000);
  }, []); */
  return (
    <ConfigProvider locale={es}>
      <CardContent
        fixed={showFixed ? showFixed : undefined}
        desktop={isDesktop ? `${isDesktop}` : ""}
      >
        <Col
          className="Col-Content--InfoFields"
          xs={24}
          sm={24}
          md={24}
          lg={14}
          xl={14}
          xxl={14}
        >
          {
            <>
              {!isDesktop && (
                <>
                  <Row style={{ height: "80px", alignContent: "center" }}>
                    <Col span={24} style={{ paddingLeft: "20px" }}>
                      <Link to="">
                        <LogoHorizontalMovil style={{ width: "130px" }} />
                      </Link>
                    </Col>
                  </Row>
                </>
              )}
              <Form
                form={form}
                name="innerSearch"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <Row gutter={[12, 16]} className="Row-Select--menu">
                  <Col
                    className="Col-activity--picker col-1"
                    style={{
                      paddingRight: "5px",
                      display: "inline-grid",
                      zIndex: "10",
                    }}
                  >
                    <label>Actividad</label>
                    <Form.Item name="activityType" hidden>
                      <input type="hidden" />
                    </Form.Item>
                    <Form.Item name="sport" hidden>
                      <input type="hidden" />
                    </Form.Item>
                    <Form.Item
                      noStyle
                      shouldUpdate={(prevValues, currentValues) =>
                        prevValues.activityType !== currentValues.activityType
                      }
                    >
                      {({ getFieldValue }) => {
                        return (
                          <Form.Item
                            name="activity"
                            rules={[{ required: false, message: "" }]}
                          >
                            <Select
                              notFoundContent="No hay datos"
                              showArrow={false}
                              placeholder="Elige una actividad"
                              allowClear
                              onChange={(value) => {
                                if (value) {
                                  const selectedActivity = getAllActivities(activities).find(
                                    (a) => String(a.id) === String(value)
                                  );
                                  if (selectedActivity) {
                                    form.setFieldsValue({
                                      activityType: selectedActivity.activityTypeId,
                                      activity: value,
                                      sport: selectedActivity.legacySportId,
                                    });
                                  }
                                } else {
                                  form.setFieldsValue({
                                    activity: undefined,
                                    sport: undefined,
                                  });
                                }
                              }}
                            >
                              {activities.length > 0 &&
                                activities.map((activityType) => (
                                  <OptGroup
                                    key={activityType.id}
                                    label={activityType.name}
                                  >
                                    {activityType.activities.map((activity) => (
                                      <Option key={activity.id} value={activity.id}>
                                        {activity.name}
                                      </Option>
                                    ))}
                                  </OptGroup>
                                ))}
                            </Select>
                          </Form.Item>
                        );
                      }}
                    </Form.Item>
                  </Col>
                  <Col className="col-2" style={{ paddingRight: "5px" }}>
                    <label>Tú Ubicación</label>
                    <Input
                      ref={(c) => {
                        antInputRef.current = c;
                        if (c) ref.current = c.input;
                      }}
                      value={placesInputController}
                      placeholder="Ingresa una dirección"
                      onChange={onPlaceChange}
                    />
                    {/*errorAddress && <div className='address-error'>Debes indicar una dirección</div>*/}
                  </Col>
                  <Col className="Col-data--picker col-3">
                    <label>Fecha</label>
                    <Form.Item
                      name="date"
                      rules={[
                        {
                          required: true,
                          message: "¡Por favor selecciona una fecha válida",
                        },
                      ]}
                      initialValue={initialDateTime.date}
                    >
                      <DatePicker
                        inputReadOnly
                        placeholder=""
                        defaultValue={moment()}
                        allowClear={false}
                        format={dateFormat}
                        disabledDate={disabledDate}
                        onChange={updateSelectedDate}
                        dateRender={(currentDate) => {
                          const dateStr = currentDate.format("YYYY-MM-DD");
                          const isClasses = getRouteActivityType() === CLASSES_ACTIVITY_TYPE;
                          const hasReservation = isClasses && calendarReservations.has(dateStr);
                          return (
                            <div className="ant-picker-cell-inner" style={{ position: "relative" }}>
                              {currentDate.date()}
                              {hasReservation && <div className="calendar-tile-dot" />}
                            </div>
                          );
                        }}
                        onPanelChange={(value) => loadCalendarReservations(value)}
                      />
                    </Form.Item>
                  </Col>
                  <Col className="Col-data--picker col-4">
                    <label>Hora</label>
                    <Form.Item
                      noStyle
                      shouldUpdate={(prevValues, currentValues) =>
                        prevValues.activityType !== currentValues.activityType
                      }
                    >
                      {({ getFieldValue }) => {
                        return (
                          <Form.Item
                            name="time"
                            rules={[
                              {
                                required: false,
                                message: "¡Por favor selecciona una hora válida",
                              },
                            ]}
                          >
                            <TimePicker
                              hideDisabledOptions
                              inputReadOnly
                              showNow={false}
                              placeholder="Cualquier hora"
                              allowClear
                              minuteStep={30}
                              format="HH:mm"
                              open={open}
                              onOpenChange={() => {
                                setOpen(!open);
                              }}
                              disabledHours={disabledHours}
                              onSelect={(date) => {
                                const currentTime = form.getFieldValue("time");
                                const oldTime = currentTime
                                  ? format(currentTime.valueOf(), "HH:mm")
                                  : null;
                                const newTime = date ? format(date.valueOf(), "HH:mm") : null;
                                if (oldTime !== newTime) {
                                  setOpen(false);
                                }
                                form.setFieldsValue({
                                  time: date,
                                });
                              }}
                              popupClassName="no-footer"
                              className="no-footer"
                            />
                          </Form.Item>
                        );
                      }}
                    </Form.Item>
                  </Col>
                  <Col className="col-5">
                    <Form.Item>
                      {isDesktop ? (
                        <Button
                          type="primary"
                          htmlType="submit"
                          style={{
                            width: "45px",
                            height: "45px",
                            borderRadius: "10px",
                          }}
                        >
                          <IconSearch style={{ margin: "5px -5px" }} />
                        </Button>
                      ) : (
                        <Button
                          type="primary"
                          htmlType="submit"
                          style={{
                            width: "100%",
                            height: "45px",
                            borderRadius: "10px",
                          }}
                        >
                          Buscar
                        </Button>
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
              <Row className="row--backtop">
                <Button
                  className="button--floating-search"
                  type="primary"
                  onClick={backToTop}
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "10px",
                  }}
                >
                  <IconSearch style={{ margin: "5px -5px" }} />
                </Button>
              </Row>

              <Row className="Row-Content--sliderFields" id="fieldsContainer">
                <Col span={22}>
                  {fetchingData && <CardField loading />}
                  {noFields && (
                    <div className="dataNotFound--container">
                      <DataNotFound />{" "}
                      <p>
                        Hemos llegado a una zona desconocida. <br />
                        {getRouteActivityType() === CLASSES_ACTIVITY_TYPE
                          ? "No tenemos clases disponibles en la zona indicada, por favor intenta en otra ciudad"
                          : "No tenemos canchas disponibles en la zona indicada, por favor intenta en otra ciudad"}
                      </p>
                    </div>
                  )}
                  {isDesktop && fields.length > 0 && (
                    <InfiniteScroll
                      scrollableTarget="fieldsContainer"
                      dataLength={fields.length}
                      next={showMoreFields}
                      hasMore={hasMoreFields}
                      endMessage={
                        <p
                          style={{
                            textAlign: "center",
                            color: "#96989A",
                            width: "100%",
                            marginTop: "30px",
                          }}
                        >
                          <b>{searchCopy.endMessage}</b>
                        </p>
                      }
                      //endMessage={'No hay más canchas que cumplan los criterios, por favor realiza otra búsqueda'}
                      loader={<CardField loading />}
                    >
                      <Col span={24}>
                        {fields.map((field, index) =>
                          field.banner ? (
                            <Card
                              key={field.iddescuento + index}
                              style={{ marginTop: "30px", border: "unset" }}
                              bodyStyle={{ padding: "unset" }}
                            >
                              {field.urldestino ? (
                                <Link
                                  to={{
                                    pathname: field.urldestino,
                                    state: history?.location?.state,
                                  }}
                                >
                                  <img
                                    src={field.urlbanner}
                                    alt="promotion-banner"
                                    style={{
                                      width: "100%",
                                      objectFit: "cover",
                                      borderRadius: "8px",
                                    }}
                                  />
                                </Link>
                              ) : (
                                <img
                                  src={field.urlbanner}
                                  alt="promotion-banner"
                                  style={{
                                    width: "100%",
                                    objectFit: "cover",
                                    borderRadius: "8px",
                                  }}
                                />
                              )}
                            </Card>
                          ) : (
                            <CardField
                              key={field.idclase || field.idcancha}
                              index={index}
                              fieldData={field}
                              timeValues={getSelectedDateTime}
                            />
                          )
                        )}
                      </Col>
                    </InfiniteScroll>
                  )}
                  {!isDesktop && fields.length > 0 && (
                    <InfiniteScroll
                      dataLength={fields.length}
                      next={showMoreFields}
                      hasMore={hasMoreFields}
                      endMessage={
                        <p
                          style={{
                            textAlign: "center",
                            color: "#96989A",
                            width: "100%",
                            marginTop: "30px",
                          }}
                        >
                          <b>{searchCopy.endMessage}</b>
                        </p>
                      }
                      //endMessage={'No hay más canchas que cumplan los criterios, por favor realiza otra búsqueda'}
                      loader={<CardField loading />}
                    >
                      <Col span={24}>
                        {fields.length > 0 &&
                          fields.map((field, index) =>
                            field.banner ? (
                              <Card
                                key={field.iddescuento + index}
                                style={{
                                  marginTop: "10px",
                                  border: "unset",
                                  borderRadius: "10px",
                                }}
                                bodyStyle={{ padding: "unset" }}
                              >
                                {field.urldestino ? (
                                  <Link
                                    to={{
                                      pathname: field.urldestino,
                                      state: history?.location?.state,
                                    }}
                                  >
                                    <img
                                      src={field.urlbannerm}
                                      alt="promotion-banner"
                                      style={{
                                        width: "100%",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                      }}
                                    />
                                  </Link>
                                ) : (
                                  <img
                                    src={field.urlbannerm}
                                    alt="promotion-banner"
                                    style={{
                                      width: "100%",
                                      objectFit: "cover",
                                      borderRadius: "8px",
                                    }}
                                  />
                                )}
                              </Card>
                            ) : (
                              <CardField
                                key={field.idclase || field.idcancha}
                                index={index}
                                fieldData={field}
                                timeValues={getSelectedDateTime}
                              />
                            )
                          )}
                      </Col>
                    </InfiniteScroll>
                  )}
                </Col>
              </Row>
            </>
          }
        </Col>
        <Col
          className="Col-Content--map"
          xs={0}
          sm={0}
          md={0}
          lg={10}
          xl={10}
          xxl={10}
        >
          <GoogleMapReact
            bootstrapURLKeys={{
              key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
              libraries: ["places"],
            }}
            options={mapOptions}
            center={{
              lat: mapCenterLocation.latitude,
              lng: mapCenterLocation.longitude,
            }}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
            defaultZoom={14}
          >
            {mapCenterLocation.latitude && mapCenterLocation.longitude && (
              <UserMarker
                lat={mapCenterLocation.latitude}
                lng={mapCenterLocation.longitude}
              />
            )}
            {sedes.length > 0 &&
              sedes.map((field, index) => (
                <SedeLocation
                  key={field.idsede}
                  data={field}
                  {...field.coordenadas}
                />
              ))}
          </GoogleMapReact>
        </Col>
      </CardContent>
    </ConfigProvider>
  );
};

export default SearchAllFields;
